import { render, staticRenderFns } from "./ClosedTable.vue?vue&type=template&id=3570d7f7&"
import script from "./ClosedTable.vue?vue&type=script&lang=js&"
export * from "./ClosedTable.vue?vue&type=script&lang=js&"
import style0 from "./ClosedTable.vue?vue&type=style&index=0&id=3570d7f7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports